import { Modal } from 'react-bootstrap';
import { Button } from '@Components/Button';

interface NoRateChangesModalProps {
  onClose: () => void;
}

export const NoRateChangesModal = ({ onClose }: NoRateChangesModalProps) => (
  <Modal show onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>No rates needed refreshing!</Modal.Title>
    </Modal.Header>
    <Modal.Body>All rates are up-to-date.</Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>Okay</Button>
    </Modal.Footer>
  </Modal>
);
